// profileLearning.js
// Whether a data profile is "learned" (Spec 2 section 5.3): it has at least one
// possible_values entry, a destination column with at least one learned source
// name, and at least one of its files has landed. Only then may Approve file
// approve, in one go, every table of a file still to review. Under a profile
// that is not yet learned, each table is reviewed and approved by hand first,
// so Decode learns its layout from the person. The approve-file gesture judges
// the same test in its transaction; the review dialog reads it to disable
// Approve file with the reason.
//
// A column whose list of learned names is empty has learned nothing, so it
// does not count.

export const isProfileLearned = (profileData) => (
  Object.values(profileData?.possible_values || {}).some((names) => Array.isArray(names) && names.length > 0)
  && (profileData?.file_stats?.status_completed || 0) >= 1
);
